import React, { useState, useEffect, Suspense } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { getBanners } from '../actions/BannersAction';
import { template } from '../constants/Configs'
import { HomeLayout1, HomeLayout2, HomeLayout3, HomeLayout4, HomeLayout5, HomeLayout7 } from '../components/AsyncComponents'
import Utils from '../services/Utils';
import Constants from '../constants/Constants';
import DeviceTypeEnum from '../constants/DeviceTypeEnum'
import { getRecentGames } from "../actions/games/GameAction";
import { changePopupVisibility } from "../actions/UserActions";
import PopupEnum from "../components/base/PopupEnum";

function Home() {
  const [deviceType, setDeviceType] = useState(Utils.isTablet() ? 'Mobile' : 'Desktop');
  const isLoggedIn = useSelector(state => state.user.isLoggedIn);
  const [recentGames, setRecentGames] = useState([])
  const { enableSiteStylesForSport } = useSelector((state) => state.settings.sportSettings);
  const uiSettingMode = useSelector((state) => state.settings.uiSettingMode);
  const dispatch = useDispatch();
  window.SportLogin = function () {
    dispatch(changePopupVisibility(PopupEnum.Login));
  }
  useEffect(() => {
    if (parseInt(template) === 7 && isLoggedIn) {
      dispatch(getRecentGames({ DeviceType: Utils.isTablet() ? DeviceTypeEnum.Mobile : DeviceTypeEnum.Desktop }))
    }
  }, [isLoggedIn])

  // useEffect(() => {
  //   window.sportApp?.Betslip?.dispatch && window.sportApp?.Betslip?.dispatch('changeTheme', uiSettingMode === '2' ? 'light': 'dark')
  // }, [uiSettingMode])

  useEffect(() => {
    !enableSiteStylesForSport && window.sportApp?.Betslip?.dispatch && window.sportApp?.Betslip?.dispatch('changeTheme', uiSettingMode === '2' ? 'light' : 'dark')
  }, [uiSettingMode, enableSiteStylesForSport])

  useEffect(() => {
    !enableSiteStylesForSport && window.sportApp?.Betslip?.dispatch && window.sportApp?.Betslip?.dispatch('changeTheme', uiSettingMode === '2' ? 'light' : 'dark')
  }, [uiSettingMode, enableSiteStylesForSport])

  useEffect(() => {
    dispatch(getBanners(Constants.HOME_PAGE, deviceType));
    window.addEventListener("resize", updateDimensions);

    return () => {
      Utils.scrollToTop();
      window.removeEventListener("resize", updateDimensions);
    }
  }, [isLoggedIn])

  const updateDimensions = () => {
    setDeviceType(oldVal => {
      const val = Utils.isTablet() ? 'Mobile' : 'Desktop';
      if (oldVal !== val) {
        dispatch(getBanners(Constants.HOME_PAGE, deviceType));

      }
      return val;
    });
  }

  const getLayout = () => {
    switch (parseInt(template)) {
      case 1:
        return <HomeLayout1 />
      case 2:
        return <HomeLayout2 />
      case 3:
        return <HomeLayout3 />
      case 4:
        return <HomeLayout4 />
      case 5:
        return <HomeLayout5 />
      default:
        return <HomeLayout7 />
    }
  }

  return (
    <Suspense fallback={<div></div>}>
      {getLayout()}
    </Suspense>
  );
}

export default Home;
